import { IControlField2, IFieldResponse } from './control-field.base';

export interface ISliderInputField extends IControlField2 {
  default_value?: number;
  upperbound_limit?: number;
}

export function toSliderField(field: IFieldResponse): ISliderInputField {
  let defaultValue = field.default_value;
  if (typeof defaultValue === 'string') {
    if (defaultValue) {
      defaultValue = Number(defaultValue);
    } else {
      defaultValue = 0;
    }
  }
  return {
    id: field.id,
    alias: field.alias,
    control_type: field.control_type,
    default_value: defaultValue as number,
    helper_text: field.helper_text,
    is_active: field.is_active,
    is_visible: field.is_visible,
    is_disabled: field.is_disabled,
    is_mandatory: field.is_mandatory,
    name: field.name,
    placement_order: field.placement_order,
    section: field.section || '',
    dtype: field.dtype,
    upperbound_limit: field.upperbound_limit,
    is_auto_fill: field.is_auto_fill,
    planner_flag: field.planner_flag,
    info_details: field.info_details,
    is_info_enable: field.is_info_enable
  };
}
